
// @ts-nocheck


export const localeCodes =  [
  "en",
  "th"
]

export const localeLoaders = {
  "en": [{ key: "../lang/en/common.ts", load: () => import("../lang/en/common.ts" /* webpackChunkName: "locale__home_runner_work_WebSite_WebSite_lang_en_common_ts" */), cache: true },
{ key: "../lang/en/policy.ts", load: () => import("../lang/en/policy.ts" /* webpackChunkName: "locale__home_runner_work_WebSite_WebSite_lang_en_policy_ts" */), cache: true },
{ key: "../lang/en/news.ts", load: () => import("../lang/en/news.ts" /* webpackChunkName: "locale__home_runner_work_WebSite_WebSite_lang_en_news_ts" */), cache: true },
{ key: "../lang/en/about-us.ts", load: () => import("../lang/en/about-us.ts" /* webpackChunkName: "locale__home_runner_work_WebSite_WebSite_lang_en_about_us_ts" */), cache: true },
{ key: "../lang/en/sustainability.ts", load: () => import("../lang/en/sustainability.ts" /* webpackChunkName: "locale__home_runner_work_WebSite_WebSite_lang_en_sustainability_ts" */), cache: true },
{ key: "../lang/en/contact-us", load: () => import("../lang/en/contact-us" /* webpackChunkName: "locale__home_runner_work_WebSite_WebSite_lang_en_contact_us" */), cache: true },
{ key: "../lang/en/home.ts", load: () => import("../lang/en/home.ts" /* webpackChunkName: "locale__home_runner_work_WebSite_WebSite_lang_en_home_ts" */), cache: true },
{ key: "../lang/en/careers.ts", load: () => import("../lang/en/careers.ts" /* webpackChunkName: "locale__home_runner_work_WebSite_WebSite_lang_en_careers_ts" */), cache: true },
{ key: "../lang/en/component.ts", load: () => import("../lang/en/component.ts" /* webpackChunkName: "locale__home_runner_work_WebSite_WebSite_lang_en_component_ts" */), cache: true }],
  "th": [{ key: "../lang/th/common.ts", load: () => import("../lang/th/common.ts" /* webpackChunkName: "locale__home_runner_work_WebSite_WebSite_lang_th_common_ts" */), cache: true },
{ key: "../lang/th/policy.ts", load: () => import("../lang/th/policy.ts" /* webpackChunkName: "locale__home_runner_work_WebSite_WebSite_lang_th_policy_ts" */), cache: true },
{ key: "../lang/th/news.ts", load: () => import("../lang/th/news.ts" /* webpackChunkName: "locale__home_runner_work_WebSite_WebSite_lang_th_news_ts" */), cache: true },
{ key: "../lang/th/about-us.ts", load: () => import("../lang/th/about-us.ts" /* webpackChunkName: "locale__home_runner_work_WebSite_WebSite_lang_th_about_us_ts" */), cache: true },
{ key: "../lang/th/sustainability.ts", load: () => import("../lang/th/sustainability.ts" /* webpackChunkName: "locale__home_runner_work_WebSite_WebSite_lang_th_sustainability_ts" */), cache: true },
{ key: "../lang/th/contact-us", load: () => import("../lang/th/contact-us" /* webpackChunkName: "locale__home_runner_work_WebSite_WebSite_lang_th_contact_us" */), cache: true },
{ key: "../lang/th/home.ts", load: () => import("../lang/th/home.ts" /* webpackChunkName: "locale__home_runner_work_WebSite_WebSite_lang_th_home_ts" */), cache: true },
{ key: "../lang/th/careers.ts", load: () => import("../lang/th/careers.ts" /* webpackChunkName: "locale__home_runner_work_WebSite_WebSite_lang_th_careers_ts" */), cache: true },
{ key: "../lang/th/component.ts", load: () => import("../lang/th/component.ts" /* webpackChunkName: "locale__home_runner_work_WebSite_WebSite_lang_th_component_ts" */), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.ts",
  "locales": [
    {
      "code": "en",
      "name": "English",
      "files": [
        "/home/runner/work/WebSite/WebSite/lang/en/common.ts",
        "/home/runner/work/WebSite/WebSite/lang/en/policy.ts",
        "/home/runner/work/WebSite/WebSite/lang/en/news.ts",
        "/home/runner/work/WebSite/WebSite/lang/en/about-us.ts",
        "/home/runner/work/WebSite/WebSite/lang/en/sustainability.ts",
        "/home/runner/work/WebSite/WebSite/lang/en/contact-us",
        "/home/runner/work/WebSite/WebSite/lang/en/home.ts",
        "/home/runner/work/WebSite/WebSite/lang/en/careers.ts",
        "/home/runner/work/WebSite/WebSite/lang/en/component.ts"
      ],
      "language": "en-US"
    },
    {
      "code": "th",
      "name": "ไทย",
      "files": [
        "/home/runner/work/WebSite/WebSite/lang/th/common.ts",
        "/home/runner/work/WebSite/WebSite/lang/th/policy.ts",
        "/home/runner/work/WebSite/WebSite/lang/th/news.ts",
        "/home/runner/work/WebSite/WebSite/lang/th/about-us.ts",
        "/home/runner/work/WebSite/WebSite/lang/th/sustainability.ts",
        "/home/runner/work/WebSite/WebSite/lang/th/contact-us",
        "/home/runner/work/WebSite/WebSite/lang/th/home.ts",
        "/home/runner/work/WebSite/WebSite/lang/th/careers.ts",
        "/home/runner/work/WebSite/WebSite/lang/th/component.ts"
      ],
      "language": "th-TH"
    }
  ],
  "defaultLocale": "th",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": true,
  "langDir": "lang",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_lang",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "https://www.tcrss.com",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "name": "English",
    "files": [
      {
        "path": "/home/runner/work/WebSite/WebSite/lang/en/common.ts"
      },
      {
        "path": "/home/runner/work/WebSite/WebSite/lang/en/policy.ts"
      },
      {
        "path": "/home/runner/work/WebSite/WebSite/lang/en/news.ts"
      },
      {
        "path": "/home/runner/work/WebSite/WebSite/lang/en/about-us.ts"
      },
      {
        "path": "/home/runner/work/WebSite/WebSite/lang/en/sustainability.ts"
      },
      {
        "path": "/home/runner/work/WebSite/WebSite/lang/en/contact-us"
      },
      {
        "path": "/home/runner/work/WebSite/WebSite/lang/en/home.ts"
      },
      {
        "path": "/home/runner/work/WebSite/WebSite/lang/en/careers.ts"
      },
      {
        "path": "/home/runner/work/WebSite/WebSite/lang/en/component.ts"
      }
    ],
    "language": "en-US"
  },
  {
    "code": "th",
    "name": "ไทย",
    "files": [
      {
        "path": "/home/runner/work/WebSite/WebSite/lang/th/common.ts"
      },
      {
        "path": "/home/runner/work/WebSite/WebSite/lang/th/policy.ts"
      },
      {
        "path": "/home/runner/work/WebSite/WebSite/lang/th/news.ts"
      },
      {
        "path": "/home/runner/work/WebSite/WebSite/lang/th/about-us.ts"
      },
      {
        "path": "/home/runner/work/WebSite/WebSite/lang/th/sustainability.ts"
      },
      {
        "path": "/home/runner/work/WebSite/WebSite/lang/th/contact-us"
      },
      {
        "path": "/home/runner/work/WebSite/WebSite/lang/th/home.ts"
      },
      {
        "path": "/home/runner/work/WebSite/WebSite/lang/th/careers.ts"
      },
      {
        "path": "/home/runner/work/WebSite/WebSite/lang/th/component.ts"
      }
    ],
    "language": "th-TH"
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
